var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vts-skip",attrs:{"href":_vm.to},on:{"click":function($event){return _vm.skipTo(_vm.to)}}},[_vm._t("default",function(){return [_vm._v("Skip to main content")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }